import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';

const DubbingHeader = ({ stats, activeJobsCount, onCreateDub }) => {
  return (
    <Box sx={{ mb: 4 }}>
      <Box sx={{
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        gap: 2,
        flexWrap: 'wrap',
        mb: 2.5,
      }}>
        <Box>
          <Typography sx={{
            fontFamily: 'Inter, sans-serif',
            fontWeight: 800,
            fontSize: { xs: '2rem', md: '2.6rem' },
            letterSpacing: '-0.03em',
            color: '#FFFFFF',
            lineHeight: 1.1,
            mb: 0.75,
          }}>
            Dubbing
          </Typography>
          <Typography sx={{
            fontFamily: 'Inter, sans-serif',
            fontSize: '0.95rem',
            color: 'rgba(255,255,255,0.45)',
            fontWeight: 400,
          }}>
            Localize content across 32 languages with AI dubbing.
          </Typography>
        </Box>

        <Button
          onClick={onCreateDub}
          startIcon={<AddIcon sx={{ fontSize: 18 }} />}
          sx={{
            backgroundColor: '#FFFFFF',
            color: '#000000',
            fontFamily: 'Inter, sans-serif',
            fontWeight: 700,
            fontSize: '14px',
            textTransform: 'none',
            px: 2.5,
            py: 1.2,
            borderRadius: '8px',
            letterSpacing: '-0.01em',
            flexShrink: 0,
            '&:hover': { backgroundColor: '#F0F0F0' },
          }}
        >
          Create a Dub
        </Button>
      </Box>

      {/* Stat pills */}
      {stats && (
        <Box sx={{ display: 'flex', gap: 1.5, flexWrap: 'wrap' }}>
          <StatPill label={`${stats.total_jobs} Total Jobs`} color="rgba(255,255,255,0.12)" textColor="rgba(255,255,255,0.7)" />
          <StatPill label={`${stats.completed_jobs} Completed`} color="rgba(34,197,94,0.12)" textColor="#22C55E" />
          <StatPill label={`${stats.failed_jobs} Failed`} color="rgba(239,68,68,0.12)" textColor="#EF4444" />
          {activeJobsCount > 0 && (
            <StatPill label={`${activeJobsCount} Processing`} color="rgba(59,130,246,0.12)" textColor="#3B82F6" pulse />
          )}
        </Box>
      )}
    </Box>
  );
};

const StatPill = ({ label, color, textColor, pulse }) => (
  <Box sx={{
    display: 'inline-flex',
    alignItems: 'center',
    gap: pulse ? 0.75 : 0,
    px: 1.5,
    py: 0.5,
    borderRadius: '6px',
    backgroundColor: color,
    fontFamily: 'Inter, sans-serif',
    fontSize: '12px',
    fontWeight: 600,
    color: textColor,
    letterSpacing: '0.01em',
  }}>
    {pulse && (
      <Box sx={{
        width: 6, height: 6, borderRadius: '50%', backgroundColor: textColor,
        animation: 'pulse 1.5s ease-in-out infinite',
        '@keyframes pulse': {
          '0%, 100%': { opacity: 1 },
          '50%': { opacity: 0.3 },
        },
      }} />
    )}
    {label}
  </Box>
);

export default DubbingHeader;
